import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(theme => ({
  text: {
    '&:nth-of-type(n+2)': {
      marginTop: theme.spacing(6)
    }
  },
  list: {
    paddingLeft: theme.spacing(6),
    margin: theme.spacing(6, 0, 0)
  },
  highlightText: {
    fontWeight: 700
  }
}));

const ColumnItem = ({ data }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { firstText, list, lastText } = data;

  return (
    <div>
      {firstText &&
        firstText.length > 0 &&
        firstText.map((item, indx) => {
          return (
            <Typography key={indx} className={classes.text} variant="body1">
              {t(item)}
            </Typography>
          );
        })}

      {list && list.length > 0 && (
        <ul className={classes.list}>
          {list.map((item, indx) => {
            return (
              <li key={indx}>
                <Typography variant="body1">
                  {item.highlightText && (
                    <span className={classes.highlightText}>
                      {t(item.highlightText)} &#8210;{' '}
                    </span>
                  )}
                  {t(item.text)}
                </Typography>
              </li>
            );
          })}
        </ul>
      )}

      {lastText &&
        lastText.length > 0 &&
        lastText.map((item, indx) => {
          return (
            <Typography key={indx} className={classes.text} variant="body1">
              {t(item)}
            </Typography>
          );
        })}
    </div>
  );
};

ColumnItem.propTypes = {
  data: PropTypes.shape({
    firstText: PropTypes.arrayOf(PropTypes.string),
    list: PropTypes.arrayOf(PropTypes.shape({})),
    lastText: PropTypes.arrayOf(PropTypes.string)
  })
};

ColumnItem.defaultProps = {
  data: {
    firstText: [],
    list: [],
    lastText: []
  }
};

export default ColumnItem;
